<template>
  <div class="col-2">
    <div class="u-hide-mobile u-text-right question-details">
      <answer-icon v-bind:assessment="item.assessment"></answer-icon>
      <div>
        <span v-if="item.assessment != 0">{{ getMarks() }} of</span>
        {{ item.marks }} mark<span v-if="item.marks > 1">s</span>
      </div>
      <div v-if="showDetails()">{{ item.topic }}</div>
      <div v-if="showDetails()">{{ item.reference }}</div>
      <a
        class="uuid-button-desktop u-pull-right"
        :href="getUuidLink(item.uuid)"
      >
        <button v-if="showDetails()" class="btn-light btn-small">
          Details
        </button>
      </a>
    </div>

    <!-- Mobile view for details -->
    <div
      v-if="showDetails()"
      class="row u-hide-tablet-only u-hide-desktop question-details"
    >
      <div class="col-7 u-inline ignore-screen">
        {{ item.topic }} ({{ item.reference }})
      </div>
      <div class="col-1 u-inline ignore-screen">
        <answer-icon v-bind:assessment="item.assessment"></answer-icon>
      </div>
      <div class="col-2 u-inline ignore-screen">
        <span v-if="item.assessment != 0">{{ getMarks() }} of</span>
        {{ item.marks }} mark<span v-if="item.marks > 1">s</span>
      </div>
      <div class="col-2 ignore-screen">
        <a class="uuid-button-mobile" :href="getUuidLink(item.uuid)">
          <button class="btn-light btn-small u-pull-right">Details</button>
        </a>
      </div>
    </div>
    <!-- Mobile view if NO details are visible (show the mark only) -->
    <div v-else class="row u-hide-tablet-only u-hide-desktop question-details">
      <div class="col-12 u-text-right">
        <em>
          <span v-if="item.assessment != 0">{{ getMarks() }} of</span>
          {{ item.marks }} mark<span v-if="item.marks > 1">s</span>
        </em>
      </div>
    </div>

    <div :id="getUuidTarget(item.uuid)" class="modal">
      <a
        :href="getUuidLink(item.uuid)"
        class="modal-overlay close-btn"
        aria-label="Close"
      ></a>
      <div class="modal-content" role="document">
        <div class="modal-header">
          <a href="#components" class="u-pull-right" aria-label="Close">
            <span class="icon"><i class="fa fa-wrapper fa-times"></i></span>
          </a>
          <div class="modal-title">Question Details</div>
        </div>
        <div class="modal-body">
          <!-- Modal content -->
          <table class="table">
            <tbody>
              <tr>
                <th>
                  Unique ID
                </th>
                <td>
                  <router-link
                    :to="{
                      name: 'question-index',
                      query: { search: item.uuid }
                    }"
                  >
                    {{ item.uuid }}
                  </router-link>
                </td>
              </tr>
              <tr>
                <th>
                  Revision
                </th>
                <td>
                  {{ item.revision }}
                </td>
              </tr>
              <tr>
                <th>Syllabus</th>
                <td>{{ item.syllabus }}</td>
              </tr>
              <tr>
                <th>Reference</th>
                <td>{{ item.reference }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import AnswerIcon from "@/components/exams/AnswerIcon";

export default {
  name: "exam-item-details",
  components: {
    AnswerIcon
  },
  props: {
    item: {},
    exam: {}
  },
  computed: {
    ...mapGetters("auth", ["userProfile", "permissions"])
  },
  methods: {
    getUuidLink(uuid) {
      return "#" + this.getUuidTarget(uuid);
    },
    getUuidTarget(uuid) {
      return uuid.slice(-12, -1);
    },
    getMarks() {
      if (this.item.assessment <= 0) {
        return 0;
      } else {
        // Divide by '2' as '2' is the correct answer and '1' is partial marks
        return (this.item.marks * this.item.assessment) / 2;
      }
    },
    showDetails() {
      let is_candidate = this.exam.candidate.id == this.userProfile.id;
      return (
        this.permissions.includes("exams.view_item") &&
        (!is_candidate || this.item.assessment != 0)
      );
    }
  }
};
</script>
